const locale = {
    placeholder: 'Vaxtı seç',
    rangePlaceholder: ['Başlama tarixi', 'Bitmə tarixi'],
};
export default locale;
